import { Box, useTheme } from "@mui/material";
import { Track } from "../../../interfaces/dtos/track"
import { Property } from "csstype";
import { statusItems, statusKeys } from "../trackPage/trackPageHelper";
import { getCountryCodeForFlag } from "../../../utils/commonUtils";
import ReactCountryFlag from "react-country-flag";

interface TrackListItemProps {
  track: Track;
  hasSelection: boolean;
}

export const TrackListItem = ({
  track, hasSelection
}: TrackListItemProps) => {

  const theme = useTheme();

  const statusItem = statusItems[track.isTrackActive ? 0 : 1];
  const statusColour: Property.Color = statusItem && statusItem.key === statusKeys.active ?
    theme.palette.success.light : theme.palette.warning.light

  const statusWidth = hasSelection ? '20px' : '70px';
  const statusDesc = hasSelection ? statusItem?.value.substring(0, 1) : statusItem?.value;

  const countryCode = track.countryCode ? getCountryCodeForFlag(track.countryCode) : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ width: '30px' }}>
        {countryCode &&
          <ReactCountryFlag
            countryCode={countryCode} svg
            style={{ fontSize: '20px', marginTop: '-4px' }}
          />
        }
      </Box>
      <Box sx={{ width: statusWidth, color: statusColour }}>
        {statusDesc}
      </Box>
      <Box sx={{ width: '35px' }}>{track.sportCode}</Box>
      <Box sx={{ width: '200px', textOverflow: 'ellipsis' }}>
        {track.shortDescription}
        <span style={{ color: theme.palette.action.disabled }}> ({track.provider})</span>
      </Box>
    </Box >
  )
}
